import { DefaultText } from './defaultText';
import { RegexValidator } from '../../validator/regexValidator';
export class Email extends DefaultText {
    constructor(element) {
        super(element);
        this.pattern = /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/;
    }
    getValidator() {
        const list = this.getDefaultValidator();
        if (this.element.value) {
            list.add(new RegexValidator(this.element.name, this.element.value, this.pattern, this.element.emailErrorMsg ? this.element.emailErrorMsg : undefined));
        }
        return list;
    }
}
//# sourceMappingURL=email.js.map